import React from "react";
import { Nav } from "@/components/Nav";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { WhyChoose } from "@/components/WhyChoose";
import { Manifesto } from "@/components/Manifesto";
import { Gallery } from "@/components/Gallery";
import { Team } from "@/components/Team";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { IntroOverlay } from "@/components/IntroOverlay";

export default function Home() {
  return (
    <>
      <IntroOverlay />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <WhyChoose />
        <Manifesto />
        <Gallery />
        <Team />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
